<template>
  <v-container>
    <v-alert
      v-model="isError"
      dismissible
      type="error"
      transition="fade-transition"
    >
      {{ errMessage }}
    </v-alert>
    <h1>Subscription Invoices</h1>
    <invoice-listing
      scope="subscription"
      :scopeID="parseInt($route.params.id)"
    />
  </v-container>
</template>

<script>
import InvoiceListing from '@/components/invoice-listing'

export default {
  data: () => ({
    isError: false,
    errMessage: null
  }),
  components: {
    InvoiceListing
  }
}
</script>
